// Taxe sur prime d'assurance du Québec (9 %), incluse dans les paiements d'assurance et non récupérable
export const TAUX_TAXE_PRIME = 9;
export const estAssurance = (categorie) => /^assurance/i.test(categorie || "");
export const taxePrime = (montant) => Math.round((montant * TAUX_TAXE_PRIME) / (100 + TAUX_TAXE_PRIME) * 100) / 100;
